<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M12.4565 2.59292L15.1955 8.73692L21.8845 9.44342C22.315 9.48892 22.488 10.0224 22.1665 10.3119L17.17 14.8144L18.5655 21.3949C18.6555 21.8184 18.2015 22.1479 17.8265 21.9319L12 18.5704L6.17349 21.9314C5.79849 22.1474 5.34499 21.8179 5.43449 21.3944L6.82999 14.8139L1.83349 10.3114C1.51199 10.0219 1.68549 9.48842 2.11549 9.44292L8.80449 8.73642L11.5435 2.59242C11.7195 2.19742 12.2805 2.19742 12.4565 2.59292Z" fill="url(#paint0_linear)"/>
<defs>
<linearGradient id="paint0_linear" x1="4.50449" y1="3.17992" x2="19.046" y2="22.6329" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFDA1C"/>
<stop offset="1" stop-color="#FEB705"/>
</linearGradient>
</defs>
</svg>
